/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.RestrictionActionResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The RestrictionActionResource model module.
   * @module model/RestrictionActionResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>RestrictionActionResource</code>.
   * A resource that includes a name, route and verb of an API that will be added to a restriction.
   * @alias module:model/RestrictionActionResource
   * @class
   * @param name {String} Required. The name of the API.
   * @param route {String} Required. The route of the API.
   * @param verb {String} Required. The verb of the API.
   */
  var exports = function(name, route, verb) {
    var _this = this;

    _this['name'] = name;
    _this['route'] = route;
    _this['verb'] = verb;
  };

  /**
   * Constructs a <code>RestrictionActionResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RestrictionActionResource} obj Optional instance to populate.
   * @return {module:model/RestrictionActionResource} The populated <code>RestrictionActionResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('route')) {
        obj['route'] = ApiClient.convertToType(data['route'], 'String');
      }
      if (data.hasOwnProperty('verb')) {
        obj['verb'] = ApiClient.convertToType(data['verb'], 'String');
      }
    }
    return obj;
  }

  /**
   * Required. The name of the API.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * Required. The route of the API.
   * @member {String} route
   */
  exports.prototype['route'] = undefined;
  /**
   * Required. The verb of the API.
   * @member {String} verb
   */
  exports.prototype['verb'] = undefined;



  return exports;
}));



